import { render, staticRenderFns } from "./Articolo.vue?vue&type=template&id=6fc7d225&"
import script from "./Articolo.vue?vue&type=script&lang=js&"
export * from "./Articolo.vue?vue&type=script&lang=js&"
import style0 from "./Articolo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports